import * as grpc from "./enums";

/**
 * Int-based enums!
 * create grpc.Enum namespace
 * necessary for client-side filtering
 * producing dynamic list of filter options
 **/
export { grpc };
